import { get, isEmpty } from 'lodash';
import { marketplaceAudiencesCollectionPath } from 'modules/campaigns/modules/common-campaign-form/components/MarketplaceAudiences/utils/andLogicUtils';

export const getIsMarketplaceAudiencesTargetingEmpty = selectedCampaign =>
    get(selectedCampaign, marketplaceAudiencesCollectionPath, []).every(group => isEmpty(group.values));
